import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeSpace'
})
export class RemoveSpacePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (Boolean(value )) {
          return value.toString().replace(/\s+/g, '').trim();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipe/remove-space.pipe.ts